import { render, staticRenderFns } from "./CloudPicture.vue?vue&type=template&id=56f23641&"
import script from "./CloudPicture.vue?vue&type=script&lang=js&"
export * from "./CloudPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports